import { handleErrorWithSentry } from '@sentry/sveltekit'
import * as Sentry from '@sentry/sveltekit'
import structuredClone from '@ungap/structured-clone'

import { PUBLIC_SENTRY_DSN } from '$app/env/public'

Sentry.init({
	dsn: PUBLIC_SENTRY_DSN,
	environment: import.meta.env.MODE,
	enabled: import.meta.env.MODE === 'production',
	tracesSampleRate: 1,
})

// If you have a custom error handler, pass it to `handleErrorWithSentry`
export const handleError = handleErrorWithSentry()

if (!('structuredClone' in globalThis)) {
	// @ts-expect-error types mismatch
	globalThis.structuredClone = structuredClone
}
